"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7221],{

/***/ 77221:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(13980);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var sf_modules__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(37555);
/* harmony import */ var _yema_designkit_webkit_molecules_Banner__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(18648);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(5632);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_4__);






var CMS_Banner = function(param) {
    var content = param.content, typeName = param.typeName, slug = param.slug;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_4__.useRouter)();
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), isBlog = ref[0], setIsBlog = ref[1];
    var handleClick = function() {
        if (content.button && content.button.link) sf_modules__WEBPACK_IMPORTED_MODULE_2__/* .links.handleRedirect */ .Ok.handleRedirect(content.button.link, router);
    };
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        if (slug === "blog" || typeName === "BlogType") setIsBlog(true);
        else setIsBlog(false);
    }, [
        isBlog,
        slug
    ]);
    if (!content) return "";
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_yema_designkit_webkit_molecules_Banner__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
        isBlog: isBlog,
        bannerInfo: content,
        handleBtnClick: handleClick
    });
};
CMS_Banner.defaultProps = {};
CMS_Banner.propTypes = {
    content: prop_types__WEBPACK_IMPORTED_MODULE_5__.object.isRequired
};
/* harmony default export */ __webpack_exports__["default"] = (CMS_Banner);


/***/ }),

/***/ 68113:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ Badge_Badge; }
});

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(47842);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(70865);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(96670);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/prop-types/index.js
var prop_types = __webpack_require__(13980);
// EXTERNAL MODULE: ../../packages/designkit/src/components/webkit/atoms/Link/index.js
var Link = __webpack_require__(35384);
// EXTERNAL MODULE: ../../node_modules/classnames/index.js
var classnames = __webpack_require__(72779);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
;// CONCATENATED MODULE: ../../packages/designkit/src/components/webkit/atoms/Badge/Badge.jsx








var Badge = function(param) {
    var className = param.className, bgColor = param.bgColor, textColor = param.textColor, type = param.type, children = param.children, href = param.href, style = param.style;
    var _obj;
    var rootClass = classnames_default()(className, "inline-block font-body", (_obj = {
        "shadow-down text-small rounded-l-none rounded-r-sm px-2 py-1": type === "generic" || type === "initial" || type === "stockout",
        "text-small rounded-xxl px-2 py-1": type === "round",
        "shadow-down text-caption leading-tight border-solid border border-brand-primary-700 rounded-sm px-1 py-0": type === "discount",
        "shadow-down font-body font-body-normal text-small underline rounded-bl-md px-2 py-1 cursor-pointer": type === "linkTop",
        "shadow-down font-body font-body-normal text-small underline rounded-tl-md px-2 py-1 cursor-pointer": type === "linkBottom",
        "bg-brand-secondary-700": !bgColor && type === "generic",
        "bg-ui-success": !bgColor && type === "round",
        "bg-brand-tertiary-500": !bgColor && type === "initial",
        "bg-ui-gray-300": !bgColor && type === "stockout",
        "bg-ui-white": !bgColor && type === "discount"
    }, (0,_define_property/* default */.Z)(_obj, bgColor, bgColor), (0,_define_property/* default */.Z)(_obj, "text-ui-white", !textColor && (type === "generic" || type === "initial" || type === "round")), (0,_define_property/* default */.Z)(_obj, "text-ui-gray-900", !textColor && type === "stockout"), (0,_define_property/* default */.Z)(_obj, "text-brand-primary-700", !textColor && type === "discount"), (0,_define_property/* default */.Z)(_obj, "text-ui-black", !textColor && (type === "linkTop" || type === "linkBottom")), (0,_define_property/* default */.Z)(_obj, "font-body-normal ".concat(textColor), textColor), _obj));
    var colorRGB = "#FDF2F1";
    var colorRGBA = colorRGB + "80";
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
        className: rootClass,
        style: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, style), {
            backgroundColor: type === "linkBottom" || type === "linkTop" ? colorRGBA : ""
        }),
        children: type === "linkBottom" || type === "linkTop" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Link["default"], {
            href: href,
            children: children
        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
            children: children
        })
    });
};
Badge.defaultProps = {
    type: "generic"
};
Badge.propTypes = {
    className: prop_types.string,
    textColor: prop_types.string,
    bgColor: prop_types.string,
    /** Badge variants: intial, stock-out, generic, discount, etc. */ type: prop_types.oneOf([
        "generic",
        "round",
        "initial",
        "stockout",
        "discount",
        "linkTop",
        "linkBottom", 
    ]),
    children: prop_types.string.isRequired,
    href: prop_types.string
};
/* harmony default export */ var Badge_Badge = (Badge);

;// CONCATENATED MODULE: ../../packages/designkit/src/components/webkit/atoms/Badge/index.js



/***/ }),

/***/ 18648:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ Banner_Banner; }
});

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/prop-types/index.js
var prop_types = __webpack_require__(13980);
// EXTERNAL MODULE: ../../node_modules/classnames/index.js
var classnames = __webpack_require__(72779);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ../../node_modules/use-media/lib/index.js
var lib = __webpack_require__(81145);
// EXTERNAL MODULE: ../../packages/icons/solid/esm/ChevronRightIcon.js
var ChevronRightIcon = __webpack_require__(12073);
// EXTERNAL MODULE: ../../packages/designkit/src/components/webkit/atoms/Link/index.js
var Link = __webpack_require__(35384);
// EXTERNAL MODULE: ../../packages/designkit/src/components/webkit/atoms/Button/index.js + 1 modules
var Button = __webpack_require__(62772);
// EXTERNAL MODULE: ../../packages/designkit/src/components/webkit/atoms/Badge/index.js + 1 modules
var Badge = __webpack_require__(68113);
// EXTERNAL MODULE: ../../packages/designkit/src/components/webkit/atoms/Image/index.js
var Image = __webpack_require__(4740);
;// CONCATENATED MODULE: ../../packages/designkit/src/components/webkit/molecules/Banner/Banner.jsx










var Title = function(param) {
    var children = param.children, isH1 = param.isH1, className = param.className;
    return isH1 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
        className: className,
        children: children
    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
        className: className,
        children: children
    });
};
var BannerContent = function(param) {
    var isBlog = param.isBlog, data = param.data, handleBtnClick = param.handleBtnClick;
    var isMobile = (0,lib/* default */.ZP)({
        maxWidth: 640
    });
    var button = data.button, alignment = data.alignment, background_color = data.background_color, text_color = data.text_color, title = data.title, is_h1 = data.is_h1, content = data.content;
    var withButton;
    if (data.hasOwnProperty("button")) withButton = button.link && button.text;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: classnames_default()("group relative h-auto w-full rounded-b-none rounded-tl-xl rounded-tr-xl bg-opacity-70 p-6", {
            "bg-ui-white": background_color === "yes",
            "bg-transparent": background_color === "no",
            "sm:rounded-xl sm:py-8 sm:px-12": !isBlog,
            "rounded-tl-xl bg-ui-white py-8 text-left shadow-up sm:w-[600px] sm:rounded-b-none sm:rounded-tr-xl sm:bg-opacity-100 sm:pl-12 sm:pr-16": isBlog,
            "sm:w-[600px] sm:text-center": alignment === "center",
            "sm:w-[600px] sm:text-left": alignment === "left",
            "sm:w-[600px] sm:text-right": alignment === "right",
            "text-center": alignment === "center" && background_color === "no" || background_color !== "no" && !isBlog,
            "text-left": alignment === "left" && background_color === "no",
            "text-right": alignment === "right" && background_color === "no",
            "h-auto min-h-[120px]": isMobile,
            "max-h-[280px] min-h-[148px]": !isMobile
        }),
        style: background_color !== "yes" && background_color !== "no" ? {
            backgroundColor: background_color
        } : {},
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Title, {
                className: classnames_default()("mb-4 font-heading font-body-normal", {
                    "text-ui-black": !text_color,
                    "text-sliderH1": !isMobile,
                    "text-h2": isMobile,
                    "mr-2": isBlog && alignment === "right"
                }),
                style: text_color ? {
                    color: text_color
                } : {},
                isH1: is_h1,
                children: title
            }),
            isBlog && button && button.link && /*#__PURE__*/ (0,jsx_runtime.jsx)(ChevronRightIcon/* default */.Z, {
                className: classnames_default()("absolute w-[15px] transform duration-300 ease-out group-hover:translate-x-1", {
                    "top-5 right-5": isMobile,
                    "top-10 right-10": !isMobile
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: classnames_default()("font-body font-body-regular", {
                    "text-ui-black": !text_color,
                    "mr-2": isBlog && alignment === "right"
                }),
                style: text_color ? {
                    color: text_color
                } : {},
                dangerouslySetInnerHTML: {
                    __html: content
                }
            }),
            withButton && !isBlog && /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                size: "md",
                className: classnames_default()("duration-300", {
                    "cursor-pointer group-hover:shadow-down": withButton && !isMobile,
                    "bg-opacity-90": isMobile
                }),
                onClick: handleBtnClick(button.link),
                children: button.text
            })
        ]
    });
};
var Banner = function(param) {
    var bannerInfo = param.bannerInfo, handleBtnClick = param.handleBtnClick, isBlog = param.isBlog;
    var isMobile = (0,lib/* default */.ZP)({
        maxWidth: 640
    });
    var center = bannerInfo.alignment === "CENTER" || bannerInfo.alignment === "center";
    var left = bannerInfo.alignment === "LEFT" || bannerInfo.alignment === "left";
    var right = bannerInfo.alignment === "RIGHT" || bannerInfo.alignment === "right";
    var bannerClass = classnames_default()("w-full flex bg-cover bg-no-repeat bg-center relative h-[350px]", {
        "justify-center": center && !isMobile,
        "justify-start": left && !isMobile,
        "justify-end": right && !isMobile,
        "items-center px-wrapper": !isBlog && !isMobile,
        "w-full items-end": isBlog && !isMobile,
        "px-wrapper items-center": !isBlog && !isMobile,
        "justify-center items-end": isMobile && (center || left || right),
        "items-end": isMobile && isBlog && (center || left || right)
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: bannerClass,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                alt: bannerInfo.title,
                src: bannerInfo.image,
                layout: "fill",
                objectFit: "cover",
                objectPosition: "center",
                quality: 70
            }),
            bannerInfo.hasOwnProperty("button") ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Link["default"], {
                href: bannerInfo.button.link,
                className: "pr-12 sm:pr-16",
                underline: false,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BannerContent, {
                    data: bannerInfo,
                    handleBtnClick: handleBtnClick,
                    isBlog: isBlog
                })
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BannerContent, {
                    data: bannerInfo,
                    handleBtnClick: handleBtnClick,
                    isBlog: isBlog
                })
            }),
            bannerInfo.hasOwnProperty("link").text && !isBlog && /*#__PURE__*/ (0,jsx_runtime.jsx)(Badge/* default */.Z, {
                className: classnames_default()("absolute right-0", {
                    "top-0 text-caption": isMobile,
                    "bottom-0": !isMobile
                }),
                type: isMobile ? "linkTop" : "linkBottom",
                children: bannerInfo.link.text
            })
        ]
    });
};
Banner.propTypes = {
    bannerInfo: prop_types.shape({
        title: prop_types.string,
        data: prop_types.object
    }).isRequired,
    handleBtnClick: prop_types.func
};
/* harmony default export */ var Banner_Banner = (Banner);

;// CONCATENATED MODULE: ../../packages/designkit/src/components/webkit/molecules/Banner/index.js



/***/ }),

/***/ 12073:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);

function ChevronRightIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M7.364 22a.345.345 0 01-.272-.14.46.46 0 01.03-.588L16.274 12l-9.15-9.27a.461.461 0 01-.032-.59c.07-.088.169-.14.273-.14a.34.34 0 01.24.104l9.152 9.272c.021.022.04.043.059.067.268.346.241.875-.058 1.18l-9.152 9.273a.338.338 0 01-.241.104z"
  }));
}
const ForwardRef = react__WEBPACK_IMPORTED_MODULE_0__.forwardRef(ChevronRightIcon);
/* harmony default export */ __webpack_exports__["Z"] = (ForwardRef);

/***/ })

}]);